exports.IonRangeSliderModule = require('./lib/ion-range-slider.module').IonRangeSliderModule;
exports.IonRangeSliderComponent = require('./lib/ion-range-slider.component').IonRangeSliderComponent;
